import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 95%;
  background-color: var(--color-white-f5);
  padding: 0px;
  margin: 0px;
  border-right: 1px solid #e0e0e0;
`;

export const FormsDiv = styled.div`
  display: flex;
  width: 100%;
  max-width: 780px;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 50px;
`;

export const DivActions = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const DivLinkCopy = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  padding: 15px;
  box-sizing: border-box;
  background-color: #fff;

  button {
    border: none;
    background-color: ${(props) =>
      props.copy ? '#77d64a8c' : '#f5f5f5' || '#f5f5f5'};
    border-radius: 5px;
    font-weight: 600;
    height: 30px;
    cursor: pointer;
  }
  button:hover {
    background-color: ${(props) =>
      props.copy ? '#a4cf8f8c' : '#77d64a8c' || '#77d64a8c'};
  }
`;
